import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { IconSize, InfoCircleIcon } from '../../icon'
import { FieldStatus } from '../types'
import styles from './FieldHelper.module.scss'
import type { FieldHelperProps } from './types'

const FieldHelper = ({
  status = FieldStatus.neutral,
  withIcon = false,
  label,
  className,
  id,
}: FieldHelperProps) => {
  const [iconName, setIconName] = useState<string | null | undefined>(null)
  useEffect(() => {
    switch (status) {
      case FieldStatus.neutral:
        setIconName('infoCircle')
        break
      case FieldStatus.critical:
        setIconName('exclamationTriangle')
        break
      case FieldStatus.positive:
        setIconName('checkCircle')
        break
      default:
        setIconName(null)
        null
    }
  }, [status])
  if (!label) {
    return null
  }
  return (
    <div className={classNames(styles['pintxo-field-helper'], className)} data-status={status}>
      {withIcon && iconName && (
        <InfoCircleIcon
          size={IconSize.small}
          outline
          className={styles['pintxo-field-helper__icon']}
        />
      )}
      <span id={id} className={styles['pintxo-field-helper__text']}>{label}</span>
    </div>
  )
}
export default FieldHelper
